<template>
  <div>
    <div
      class="mb-4 d-flex"
      v-for="(item, index) in messages"
      :class="item.user_type"
    >
      <img
        v-if="item.user_type == 'admin'"
        :src="`${publicPath}/img/rcp/icon/cs-profile.png`"
        class="img-circle img-thumbnail p-0 avatar mr-2"
        alt="avatar"
      />
      <div
        class="message w-75 fz-14"
        :class="
          item.user_type == 'admin' ? 'mr-auto bg-upload-payment' : 'ml-auto'
        "
      >
        <!-- Handle Image Files -->
        <div v-if="item.info && getFileType(item.info.fileURL) == 'image'">
          <a :href="item.info.fileURL" target="_blank">
            <img :src="item.info.fileURL" />
          </a>
          <div>{{ getMessage(item.message, item.info.encodeURL) }}</div>
        </div>

        <!-- Handle PDF Files -->
        <div v-else-if="item.info && getFileType(item.info.fileURL) == 'pdf'">
          <a
            :href="item.info.fileURL"
            target="_blank"
            class="d-flex align-items-center"
          >
            <img
              :src="`${publicPath}/img/rcp/icon/file-download.png`"
              width="35px"
            />
            <div class="d-flex flex-column w-100 px-2">
              <span class="fz-12 fw-500 text-grey3">{{
                getFileName(item.info.fileURL)
              }}</span>
              <span class="fz-10 fw-500 text-grey4">{{
                formatBytes(item.info.fileSize)
              }}</span>
            </div>
            <img
              :src="`${publicPath}/img/rcp/icon/download2.png`"
              width="34px"
              class="ml-auto"
            />
          </a>
          <div>{{ getMessage(item.message, item.info.encodeURL) }}</div>
        </div>

        <!-- Handle Link Messages -->
        <div v-else-if="isURL(item.message)">
          <!-- Internal Link - Use router-link -->
          <router-link
            v-if="isInternalLink(item.message)"
            :to="getInternalPath(item.message)"
            class="chat-link internal-link"
          >
            <div class="link-preview">
              <div class="link-icon">
                <i
                  class="fas fa-link"
                  style="font-size: 20px; color: #3b82f6"
                ></i>
              </div>
              <div class="link-content">
                <div class="link-title">{{ getLinkTitle(item.message) }}</div>
                <div class="link-url">{{ item.message }}</div>
              </div>
              <div class="link-arrow">
                <img
                  :src="`${publicPath}/img/rcp/icon/arrow-right.png`"
                  width="16px"
                  alt="arrow"
                />
              </div>
            </div>
          </router-link>

          <!-- External Link - Use regular anchor tag -->
          <a
            v-else
            :href="item.message"
            target="_blank"
            rel="noopener noreferrer"
            class="chat-link external-link"
          >
            <div class="link-preview">
              <div class="link-icon">
                <img
                  :src="`${publicPath}/img/rcp/icon/external-link.png`"
                  width="20px"
                  alt="external link"
                />
              </div>
              <div class="link-content">
                <div class="link-title">{{ getLinkTitle(item.message) }}</div>
                <div class="link-url">{{ item.message }}</div>
              </div>
              <div class="link-arrow">
                <img
                  :src="`${publicPath}/img/rcp/icon/external-arrow.png`"
                  width="16px"
                  alt="external arrow"
                />
              </div>
            </div>
          </a>
        </div>

        <!-- Regular Text Message -->
        <span v-else v-html="formatMessage(item.message)"></span>
      </div>

      <img
        v-if="item.user_type == 'member'"
        src="http://ssl.gstatic.com/accounts/ui/avatar_2x.png"
        class="img-circle img-thumbnail p-0 avatar ml-2"
        alt="avatar"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      messages: [],
      // Define internal domains that should use router-link
      internalDomains: [
        "rcpaylink.com",
        "d-card.rcpaylink.com",
        "elite.rcpaylink.com",
        "epocard.rcpaylink.com",
        "vp.rcpaylink.com",
        "mkcard.rcpaylink.com",
        "junca.rcpaylink.com",
        "irx.rcpaylink.com",
        "rc365.rcpaylink.com",
        "gvv.rcpaylink.com",
        "pinnacle.rcpaylink.com",
        "jp.rcpaylink.com",
      ],
      // Route mappings for internal paths
      routeMappings: {
        "card-replacement": "card-replacement",
        "card-management": "card-management",
        dashboard: "dashboard",
        profile: "profile",
        wallet: "wallet",
        transaction: "transaction",
      },
    };
  },
  props: ["list"],
  methods: {
    getFileName(url) {
      let arr = url.split("/");
      return arr[arr.length - 1];
    },

    getFileType(url) {
      let indexImage = this.indexOfImage(url);
      let indexPDF = url.indexOf(".pdf");
      let type = "";

      if (indexImage != -1) {
        type = "image";
      } else if (indexPDF != -1) {
        type = "pdf";
      }

      return type;
    },

    indexOfImage(url) {
      let index = url.indexOf(".png");
      index = index == -1 ? url.indexOf(".jpg") : index + 4;
      index = index == -1 ? url.indexOf(".jpeg") : index + 4;
      index = index == -1 ? url.indexOf(".gif") : index + 5;

      return index != -1 ? index + 4 : index;
    },

    getMessage(str_message, encodeURL) {
      let ret = str_message.replace(encodeURL, "");
      ret = ret.split(/(\\|\/)/g).pop();
      return ret;
    },

    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },

    // Check if message is a URL
    isURL(message) {
      const urlRegex =
        /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/i;
      const simpleUrlRegex = /^https?:\/\/.+/i;
      return (
        simpleUrlRegex.test(message.trim()) || urlRegex.test(message.trim())
      );
    },

    // Check if URL is internal (should use router-link)
    isInternalLink(url) {
      try {
        const urlObj = new URL(url);
        const hostname = urlObj.hostname;

        // Check if hostname matches any internal domains
        return this.internalDomains.some(
          (domain) => hostname === domain || hostname.endsWith("." + domain)
        );
      } catch (e) {
        // If URL parsing fails, treat as external
        return false;
      }
    },

    // Extract internal path for router-link
    getInternalPath(url) {
      try {
        const urlObj = new URL(url);
        let pathname = urlObj.pathname;

        // Remove leading slash if present
        if (pathname.startsWith("/")) {
          pathname = pathname.substring(1);
        }

        // Handle specific route mappings
        const pathParts = pathname.split("/");
        const mainPath = pathParts[0];

        if (this.routeMappings[mainPath]) {
          // If we have parameters (like ODE1 in card-replacement/ODE1)
          if (pathParts.length > 1) {
            return {
              name: this.routeMappings[mainPath],
              params: { id: pathParts[1] },
            };
          } else {
            return { name: this.routeMappings[mainPath] };
          }
        }

        // Default: use the pathname as is
        return pathname || "/";
      } catch (e) {
        console.error("Error parsing internal URL:", e);
        return "/";
      }
    },

    // Get link title for display
    getLinkTitle(url) {
      try {
        const urlObj = new URL(url);
        let pathname = urlObj.pathname;

        // Remove leading slash
        if (pathname.startsWith("/")) {
          pathname = pathname.substring(1);
        }

        const pathParts = pathname.split("/");
        const mainPath = pathParts[0];

        // Generate readable titles
        const titles = {
          "card-replacement": "Card Replacement",
          "card-management": "Card Management",
          dashboard: "Dashboard",
          profile: "Profile",
          wallet: "Wallet",
          transaction: "Transaction History",
        };

        if (titles[mainPath]) {
          return pathParts.length > 1
            ? `${titles[mainPath]} - ${pathParts[1]}`
            : titles[mainPath];
        }

        // Default: capitalize and format path
        return (
          mainPath
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ") || "Link"
        );
      } catch (e) {
        return "Link";
      }
    },

    // Format regular messages (handle potential inline links)
    formatMessage(message) {
      // Handle inline URLs in regular text
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      return message.replace(urlRegex, (url) => {
        if (this.isInternalLink(url)) {
          // For inline internal links, we'll just show them as text with styling
          // since we can't use router-link inside v-html
          return `<span class="inline-internal-link">${url}</span>`;
        } else {
          return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="inline-external-link">${url}</a>`;
        }
      });
    },
  },

  mounted: function () {
    this.messages = this.list;
  },
};
</script>

<style scoped src="@/assets/css/chat.css"></style>

<style scoped>
/* Link Preview Styles */
.chat-link {
  display: block;
  text-decoration: none;
  color: inherit;
  margin: 8px 0;
}

.link-preview {
  display: flex;
  align-items: center;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f9fafb;
  transition: all 0.2s ease;
}

.chat-link:hover .link-preview {
  background: #f3f4f6;
  border-color: #d1d5db;
  text-decoration: none;
}

.internal-link .link-preview {
  border-left: 4px solid #3b82f6;
}

.external-link .link-preview {
  border-left: 4px solid #10b981;
}

.link-icon {
  flex-shrink: 0;
  margin-right: 12px;
}

.link-content {
  flex: 1;
  min-width: 0;
}

.link-title {
  font-weight: 600;
  font-size: 14px;
  color: #1f2937;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.link-url {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.link-arrow {
  flex-shrink: 0;
  margin-left: 8px;
}

/* Inline Link Styles */
.inline-internal-link {
  color: #3b82f6;
  font-weight: 500;
  text-decoration: underline;
}

.inline-external-link {
  color: #10b981;
  text-decoration: none;
}

.inline-external-link:hover {
  text-decoration: underline;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .link-preview {
    padding: 10px;
  }

  .link-title {
    font-size: 13px;
  }

  .link-url {
    font-size: 11px;
  }
}
</style>
